const licenseStatusCode = {
  Activated: 0,
  Deactivated: 1,
  Uninstalled: 2
};

export default licenseStatusCode;
